export default {
  CP: {
    name: "Congé Payé (CP)",
    value: "CP"
  },
  CS: {
    name: "Congé sans Solde",
    value: "CS"
  },
  OTHER: {
    name: "Autre (Parental ...)",
    value: "OTHER"
  },
  SIMPLE_ABSENCE: {
    name: "Absence temporaire",
    value: "SIMPLE_ABSENCE"
  },
  RECOVERY_REQUEST: {
    name: "Déclaration d'heures supplémentaires",
    value: "RECOVERY_REQUEST"
  },
  RECOVERY_TIME_REQUEST: {
    name: "Récupération d'heures supplémentaires",
    value: "RECOVERY_TIME_REQUEST"
  }
};
